/** 起讫楼层分布（按交通模式比例，设计文档 3.3 / traffic/od-matrix.ts）。 */
import type { SceneConfig, TrafficMode } from '../config-schema';
import type { RngStream } from '../rng';

export interface OD {
  origin: number;
  dest: number;
}

/** 非大厅楼层集合。 */
function nonLobbyFloors(scene: SceneConfig): number[] {
  const out: number[] = [];
  for (let f = 0; f < scene.floors; f++) if (f !== scene.lobbyFloor) out.push(f);
  return out;
}

/**
 * 按交通模式采样一名乘客的起讫楼层（确定性，源自 od 随机流）。
 * - 上行：origin=大厅，dest 分布于上层；
 * - 下行：origin 分布于上层，dest=大厅；
 * - 层间：origin/dest 均分布于非大厅且 origin≠dest。
 */
export function sampleOD(scene: SceneConfig, mode: TrafficMode, od: RngStream): OD {
  const lobby = scene.lobbyFloor;
  const upper = nonLobbyFloors(scene);
  const r = od.next();
  let type: 'up' | 'down' | 'inter';
  if (r < mode.upPeak) type = 'up';
  else if (r < mode.upPeak + mode.downPeak) type = 'down';
  else type = 'inter';

  switch (type) {
    case 'up':
      return { origin: lobby, dest: od.pick(upper) };
    case 'down':
      return { origin: od.pick(upper), dest: lobby };
    case 'inter': {
      if (upper.length >= 2) {
        const origin = od.pick(upper);
        let dest = od.pick(upper);
        let guard = 0;
        while (dest === origin && guard++ < 8) dest = od.pick(upper);
        if (dest === origin) dest = lobby; // 退化兜底
        return { origin, dest };
      }
      // 上层不足 2 个 → 退化为上行
      return { origin: lobby, dest: od.pick(upper) };
    }
  }
}
